/**
 * External dependencies
 */
import { get } from 'lodash';

export const getAllPlanNames = (state) => get(state, ['planNames', 'items'], {});

export const requestingPlanNames = (state) => get(state, ['planNames', 'requesting'], false);

export const errorRequestingPlanNames = (state) => get(state, ['planNames', 'error'], false);
